var map = {
	"./main-base.webp": 332,
	"./main-drone.webp": 833,
	"./main-handL.webp": 216,
	"./main-handR.webp": 46,
	"./main-head.webp": 71,
	"./video-base.webp": 320,
	"./video-ring.webp": 603,
	"./web-base.webp": 859,
	"./web-handFar.webp": 296,
	"./web-handNear.webp": 489,
	"./web-head.webp": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 427;